import React from 'react';

type TRebooksCellDetailsProps = {
    title: React.ReactNode;
    subtitle?: React.ReactNode;
};

export const RebooksCellDetails = ({
    title,
    subtitle,
}: TRebooksCellDetailsProps) => (
    <div className="rebooks-cell-details">
        <span className="rebooks-cell-title">{title}</span>
        {!!subtitle && (
            <span className="rebooks-cell-subtitle">{subtitle}</span>
        )}
    </div>
);
